import { Button, Icon } from '@wtfalch/design';
import { useEffect, useState } from 'react';

import { formatDuration } from './CallDock.tsx';

function people(count: number): string {
  return count === 1 ? 'One person' : `${count} people`;
}

/**
 * The top of the call screen: what the call is, who is on it, how long it has
 * run and that it is encrypted in transit. Calls are not end-to-end encrypted
 * (wtfalch/calls#12), so the note says what is true: the media is encrypted
 * on its way to the calls server, which can read it there.
 */
export function CallHeader({
  heading,
  count,
  startedAt,
  onInvite,
  inviteBusy,
  inviteNote,
  onMinimize,
}: {
  heading: string;
  count: number;
  startedAt: number;
  /** Present for a member: makes the guest link and copies it. */
  onInvite?: () => void;
  inviteBusy?: boolean;
  /** What the last Invite did, said once ("Guest link copied."). */
  inviteNote?: string | null;
  onMinimize?: () => void;
}) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    setNow(Date.now());
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <header className="flex flex-wrap items-center gap-3 flex-none px-4 py-3 border-b border-border">
      <span className="flex flex-col flex-1 min-w-0">
        <h2 className="h3 truncate">{heading}</h2>
        <span className="text-xs text-muted">
          {people(count)} · {formatDuration(now - startedAt)} · encrypted in transit
        </span>
      </span>
      <span className="text-xs text-muted" role="status">
        {inviteNote}
      </span>
      {onInvite && (
        <Button size="sm" disabled={inviteBusy} onPress={onInvite}>
          <Icon name="user-plus" size={16} />
          <span>Invite</span>
        </Button>
      )}
      {onMinimize && (
        <Button
          size="sm"
          iconOnly
          aria-label="Keep it small and go back to the room"
          onPress={onMinimize}
        >
          <Icon name="minimize" size={16} />
        </Button>
      )}
    </header>
  );
}
